'use client';

import { useMsal } from '@azure/msal-react';
import { useCallback, useEffect } from 'react';

export function useMSALLogout() {
  const {
    instance,
    accounts,
  } = useMsal();

  const logout = useCallback(async () => {
    if (accounts.length > 0) {
      // Ensure instance is initialized before logout
      try {
        await instance.logoutRedirect({
          account: accounts[0],
        });
      } catch (error) {
        // If logout fails due to initialization, try initializing first
        console.warn('MSAL logout failed, attempting to initialize:', error);
        await instance.initialize();
        await instance.logoutRedirect({
          account: accounts[0],
        });
      }
    }
  }, [instance, accounts]);

  useEffect(() => {
    logout();
  }, [logout]);
}
